// THEME
export const ADD_THEME = 'ADD_THEME';
export const REMOVE_THEME = 'REMOVE_THEME';
export const RESET_THEME = 'RESET_THEME';
